import { Pipe, PipeTransform } from '@angular/core';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { BankStatementRuleConditionKindEnum } from '@zaoblako/shared/modules/document/enums/bank.statement.rule.condition.kind.enum';
import { BankStatementRuleConditionKindEnumI18n } from '@zaoblako/shared/modules/document/i18n/bank.statement.rule.condition.kind.enum.i18n';

@Pipe({
  name: 'bankStatementRuleConditionKindName',
  standalone: true
})
export class BankStatementRuleConditionKindNamePipe implements PipeTransform {
  public transform(kind: BankStatementRuleConditionKindEnum): string {
    return BankStatementRuleConditionKindEnumI18n[I18nLocalesEnum.RU_RU][kind] || '';
  }
}
